import { ModMenuItem } from '@moderneinc/design-system-components';
import { usePopupState } from 'material-ui-popup-state/hooks';
import React, { type FunctionComponent, useContext } from 'react';
import { ConfigurationContext } from '../../../contexts/config.context';
import { ModerneCliDialog } from './moderne-cli-dialog.component';

type LabeledLink = {
  label: string;
  uri: string;
};

export const ModerneCli: FunctionComponent<{
  cliLinkOverride?: LabeledLink;
}> = ({ cliLinkOverride }) => {
  const popupState = usePopupState({
    variant: 'dialog',
    popupId: 'moderne-cli-dialog'
  });
  const { config } = useContext(ConfigurationContext);
  const cliBaseUrl = `https://${config.name}.moderne.io`;

  if (cliLinkOverride) {
    return (
      <ModMenuItem onClick={() => window.open(cliLinkOverride.uri, '_blank')}>
        {cliLinkOverride.label}
      </ModMenuItem>
    );
  }

  return (
    <React.Fragment>
      <ModMenuItem
        data-testid="account-menu-moderne-cli"
        onClick={() => popupState.open()}
      >
        Moderne CLI
      </ModMenuItem>
      <ModerneCliDialog popupState={popupState} cliBaseUrl={cliBaseUrl} />
    </React.Fragment>
  );
};
